import { render } from "./CardWithLineGeneric.vue?vue&type=template&id=a20c4322"
import script from "./CardWithLineGeneric.vue?vue&type=script&lang=js"
export * from "./CardWithLineGeneric.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__